/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {SpoDetailPageComponent} from './spo-detail-page.component';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {MaterialListModule} from '../../shared/material-list/material-list.module';
import {SpoDetailModule} from '../../shared/spo-detail/spo-detail.module';
import {SingleMaterialStatusModule} from '../../shared/single-material-status/single-material-status.module';
import {SpoSharedModule} from '../shared/spo-shared.module';

@NgModule({
    declarations: [
        SpoDetailPageComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        MaterialListModule,
        SpoDetailModule,
        SpoSharedModule,
        SingleMaterialStatusModule
    ],
    exports: [SpoDetailPageComponent]
})

export class SpoDetailPageModule {
}
